import {
  UPDATE_CROPPER_VALUES,
  TOGGLE_CROPPER_RATIO_LOCK,
  SET_CROPPER_ACTIVE,
  SET_ACTIVE_PRESET_BY_ID,
  SET_CROPPER_CHANGED_STATUS,
  SET_CROPPER_MODAL,
  SET_CROPPER_REDIRECT,
} from '../types/cropper.types'

export const updateCropperValues = (data) => ({ type: UPDATE_CROPPER_VALUES, payload: data })
export const toggleCropperRatioLock = (data) => ({ type: TOGGLE_CROPPER_RATIO_LOCK, payload: data })
export const setCropperActive = (data) => ({ type: SET_CROPPER_ACTIVE, payload: data })
export const setActivePresetById = (data) => ({ type: SET_ACTIVE_PRESET_BY_ID, payload: data })
export const setCropperChangedStatus = (status) => ({ type: SET_CROPPER_CHANGED_STATUS, payload: status })
export const setCropperModal = (status) => ({ type: SET_CROPPER_MODAL, payload: status })
export const setCropperRedirect = (to) => ({ type: SET_CROPPER_REDIRECT, payload: to })
